import {
  BiChangeSetDetail,
  BiChangeSetStatus,
} from '@euler/model/bi/change-set';

/** Where a change set stands, as the card tells it. */
export enum BiChangePhase {
  Pending = 'pending',
  Applied = 'applied',
  Discarded = 'discarded',
  /** The dashboard moved on after it was proposed. */
  Stale = 'stale',
  /** Nobody tapped it within its 24 hours. */
  Expired = 'expired',
}

export function biChangePhase(
  detail: BiChangeSetDetail,
  now: number,
): BiChangePhase {
  const { status, expiresAt } = detail.changeSet;
  switch (status) {
    case BiChangeSetStatus.Pending:
      return BiChangePhase.Pending;
    case BiChangeSetStatus.Applied:
      return BiChangePhase.Applied;
    case BiChangeSetStatus.Discarded:
      return BiChangePhase.Discarded;
    case BiChangeSetStatus.Stale:
      // The server reads a pending set past its expiry as stale too.
      return new Date(expiresAt).getTime() <= now
        ? BiChangePhase.Expired
        : BiChangePhase.Stale;
  }
}
